import { ModelBase } from 'store/model-base';

export class NavCart extends ModelBase {
    public static storeName: string = 'navCart';

    public itemCount: number;
}
